<script setup lang="ts">
// Le titre se pose sur le papier, au-dessus d'un panneau blanc qui prend la hauteur restante.
defineProps<{ label: string }>();
</script>

<template>
  <section class="flex min-h-0 flex-col gap-[9px]">
    <h2
      class="text-encre-douce px-[1px] text-[12px] leading-[14px] font-semibold tracking-[0.9px] uppercase"
    >
      {{ label }}
    </h2>
    <div class="bg-carte flex min-h-0 flex-1 flex-col rounded-[24px] p-5">
      <slot />
    </div>
  </section>
</template>
